/*Este componente se instancia en polizas, pólizas móvil y en productos móvil.
Al inicio de render, tenemos un tache y una flecha. La flecha sólo se muestra
si al instanciarlo le pasamos showArrow con true como valor y el tache funciona
al revés. En pólizas le damos true y en productos false.
La callback de la flecha es contextual. Sirve para regresar a las pólizas o para
regresar a la vista principal del producto.
*/
import React from 'react';
import Slider from 'react-slick';
import { connect } from "react-redux";
import { servicios } from "../../properties";

const mapDispatch = (dispatch) => {
	return {
		addEvento: (evento) => {
			dispatch({ "type": "HOME_SET_EVENT", "evento": evento});
		}
	};
};

class VidaProducto extends React.Component {
  state = {
    "position": 0,
    "active": "inicioVida",
    "proteccion" : "hide",
    "ahorro" : "hide",
    "educacion" : "hide",
    "retiro" : "hide",
    "coberturas": "hide",
    "tips": "hide",
    "siniestros": "hide",
    "inicioVida" : "",
  }
  scroll = (factor) => {
    /*Cada presentación tiene un número distinto de diapositivas.
    Si hubiera que quitarlas o poner más, sólo hay que cambiar el multiplicador.
    Ojo: el multiplicador es igual al número de diapositivas - 1.
    Las unidades que estamos empleando para factor, limit y slideSize corresponden a pixeles.
    */
    var limit;
    var slideSize = 795;
    switch (this.state.active) {
      case "proteccion":
        limit = slideSize*3;
        break;
      case "ahorro":
        limit = slideSize*8;
        break;
      case "educacion":
        //Sólo hay un slide
        break;
      case "retiro":
        limit = slideSize*3;
        break;
      case "coberturas":
        limit = slideSize*1;
        break;
      case "tips":
        break;
      case "siniestros":
        break;
      default:

    }

    if (factor < 0) {
      if (this.state.position > 0) {
        $(".desc-wrap").animate({
              scrollLeft: this.state.position + factor
            }, 800);
        this.setState({
          "position": this.state.position + factor
        });
      }
    } else if (factor > 0) {
      if (this.state.position < limit) {
        $(".desc-wrap").animate({
              scrollLeft: this.state.position + factor
            }, 800);
        this.setState({
          "position": this.state.position + factor
        });
      }
    }
  }

  showVida = (seccion) => {
    var temporal = {};
    switch (seccion) {
      case "proteccion":
        temporal.proteccion = "show";
        temporal.inicioVida = "hide";
        temporal.active = "proteccion";
        this.props.addEvento("Producto-Vida-Proteccion");
        break;
      case "ahorro":
        temporal.ahorro = "show";
        temporal.inicioVida = "hide";
        temporal.active = "ahorro";
        this.props.addEvento("Producto-Vida-PAhorro");
        break;
      case "educacion":
        temporal.educacion = "show";
        temporal.inicioVida = "hide";
        temporal.active = "educacion";
        this.props.addEvento("Producto-Vida-PEducacion");
        break;
      case "retiro":
        temporal.retiro = "show";
        temporal.inicioVida = "hide";
        temporal.active = "retiro";
        this.props.addEvento("Producto-Vida-PRetiro");
        break;
      case "coberturas":
        temporal.coberturas = "show";
        temporal.inicioVida = "hide";
        temporal.active = "coberturas";
        this.props.addEvento("Producto-Vida-Coberturas");
        break;
      case "tips":
        temporal.tips = "show";
        temporal.inicioVida = "hide";
        temporal.active = "tips";
        this.props.addEvento("Producto-Vida-Tips");
        break;
      case "siniestros":
        temporal.siniestros = "show";
        temporal.inicioVida = "hide";
        temporal.active = "siniestros";
        this.props.addEvento("Producto-Vida-Siniestros");
        break;
      case "inicioVida":
        temporal.proteccion = "hide";
        temporal.ahorro = "hide";
        temporal.educacion = "hide";
        temporal.retiro = "hide";
        temporal.coberturas = "hide";
        temporal.tips = "hide";
        temporal.siniestros = "hide";
        temporal.inicioVida = "show";
        temporal.active = "inicioVida";
        this.props.addEvento("Producto-Vida-Inicio");
        break;
    }
    temporal.position = 0;
    this.setState(temporal);
  }

  componentDidMount = () => {
    $("#menu-productos-nativo").addClass("menu-productos-movil");
  }

  componentWillUnmount = () => {
    $("#menu-productos-nativo").removeClass("menu-productos-movil");
  }

  render() {

    let sliderSettings = {
      dots: false,
      infinite: false,
      speed: 300,
      controls: false,
      arrows: false,
      slidesToShow: 1,
      centerMode: true,
      centerPadding: "50px",
    }

    return <div className="producto-contenedor">
      <div className={this.props.showArrow ? "productos-back-arrow" : "hide"}>
        <img onClick={ this.state.inicioVida == "hide" ? this.showVida.bind(this, "inicioVida") : this.props.goBack } src={ require("../../img/arrow-back.svg") } />
      </div>
      <div className={!this.props.showArrow && this.state.inicioVida == "hide" ? "productos-tache" : "hide"} >
        <img onClick={this.showVida.bind(this, "inicioVida")} src={ require("../../img/icon_close.png") } />
      </div>
      <div className="productos-wrapper">
        { servicios.dominio =="gc-qa.gnp.com.mx" &&
          <iframe frameBorder="0" scrolling="yes" style={{"overflow":"hidden","width":"100%"}} height="900" width="100%"
            src="https://clientes-qa.gnp.com.mx/content/gnp-pp/mx/es/gnp-movil/productos/vida.html">
          </iframe>
        }
        { servicios.dominio =="gc-uat.gnp.com.mx" &&
          <iframe frameBorder="0" scrolling="yes" style={{"overflow":"hidden","width":"100%"}} height="900" width="100%"
            src="https://clientes-uat.gnp.com.mx/content/gnp-pp/mx/es/gnp-movil/productos/vida.html">
          </iframe>
        }
        { servicios.dominio =="gc-pro.gnp.com.mx" &&
          <iframe frameBorder="0" scrolling="yes" style={{"overflow":"hidden","width":"100%"}} height="900" width="100%"
            src="https://www.gnp.com.mx/content/gnp-pp/mx/es/gnp-movil/productos/vida.html">
          </iframe>
        }
      </div>
    </div>
  }

}
export default connect(null,mapDispatch)(VidaProducto);



// WEBPACK FOOTER //
// ./src/home/productos/vidaProducto.cmpt.js